import slick from '@accessible360/accessible-slick';
import $ from 'jQuery';

export default function () {


  $(function() {
    initialize_auto_sliders();
  });


  const slickDefaults = {
    fade: false,
    dots: true,
    arrows: true,
    adaptiveHeight: true,
    arrowsPlacement: `afterSlides`,
  };


  class Slider {
    /**
     * Slider Constructor
     * @param {HTML Element} element Element to transform into a slick slider.
     * @param {object} options Optional settings to overwrite the defaults.
     */
    constructor(element, options) {
      // Grabs reference to the passed in element.
      this.element = element;

      // We can pass in alternate options to overwrite the defaults.
      this.settings = { ...slickDefaults, ...options };

      // Sets a slider variable from the returned slick slider instance built.
      this.slider = this.build();

      // Calls a utility ready function when everything is done.
      this.ready();
    }

    /**
     * Builds out a slick slider from the element and the settings.
     * @returns jQuery Element
     */
    build() {
      return $(this.element).slick(this.settings);
    }

    /**
     * Utility function to add a ready class to the element.
     */
    ready() {
      this.element.classList.add('ready');
    }
  }


  function initialize_auto_sliders() {
    const $carousels = $('.col-slider');

    if ($carousels.length) {

      $('.images-carousel', $carousels).each(function() {
        const $thisSlider = $(this);
        let el = $thisSlider[0];
        const $sliderContainer = $thisSlider.closest('.images-carousel');

        const slickSettings = {
          fade: false,
          dots: false,
          arrows: true,
          adaptiveHeight: false,
          variableWidth: true,
          infinite: true,
          speed: 250,
          autoplay: false,
          autoplaySpeed: 2000,
          slidesToScroll: 1,
          slidesToShow: 1,
          centerMode: false,
          asNavFor: '.slider-nav-vertical-homepage',
          prevArrow: $('.slick-prev-homepage'),
          nextArrow: $('.slick-next-homepage'),

          // // -- RESPONSIVE OPTIONS --
          // slidesToShow: 3, // show three items at a time at larger viewports.
          /*responsive: [
             {
               breakpoint: 1100,
               settings: {
                 slidesToShow: 5
               }
             },
             {
               breakpoint: 800,
               settings: {
                 slidesToShow: 3,
               }
             }
          ]*/
        };


        if (!el.Slider) {
          el.Slider = new Slider(el, slickSettings);
        }
      });

      $('.slider-nav-vertical-homepage').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.images-carousel',
        dots: false,
        arrows: false,
        centerMode: true,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
      });
    }
  }
}
